import {
  Autocomplete,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Pan from "../../assets/svg/PenEtat.svg";
import defaultImage from "../../assets/svg/defultImage.svg";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CircleIcon from "@mui/icons-material/Circle";
import "./CategoryProfile.css";
import "./Categories.css";
import {
  Add,
  DeleteOutline,
  DeleteOutlineOutlined,
  Edit,
  InfoOutlined,
  Person,
  Square,
} from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { RightOutlined } from "@ant-design/icons";
import { Modal } from "react-bootstrap";
import Emptyfile1 from "../../assets/svg/Emptyfile1.svg";
import Camera from "../../assets/svg/Camera.svg";
import AddPhoto from "../../assets/svg/AddPhoto.svg";
import deleteIcon from "../../assets/svg/delete.png";
import { toast } from "react-toastify";
import DeleteModal from "../../components/Modals/DeleteModal";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Modal as BootstrapModal } from "react-bootstrap";
import UpdateProperties from "./UpDateProperties";
import AddProperties from "./AddProperties";
import EditModal from "./EditModal";
import NotFound from "../../components/SharedModule/NotFound";
import { useSelector } from "react-redux";
export const newHost = "https://estbn.com/EstbnNew/public/api/"


const PropertiesValues = ({ properityValues = [], propertyId, token, getCategoryById }) => {
  const [allValues, setAllValues] = useState(properityValues);
  const [valueId, setValueId] = useState(null);
  const [removeValueShow, setRemoveValueShow] = useState(false);
  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      values: [{ value: "", show_to_user: 0 }],
    },
  });

  const { fields, append } = useFieldArray({
    name: "values",
    control,
  });

  useEffect(() => {
    if (fields.length === 0) {
      append({ value: "" , show_to_user: 0});
    }
  }, [fields, append]);

  const createPropertyValue = async (data) => {
    const formData = new FormData()
   data.values.forEach((item, index)=>{
    formData.append(`values[${index}][value]`, item.value)
    formData.append(`values[${index}][show_to_user]`, item.show_to_user)
    }
    
    )
   
    
   

    
    
    try {
      const response = await axios.post(
        `${newHost}portal/properties/${propertyId}/values`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.data.message);

    const newEntries = response.data.data.data;

if (Array.isArray(newEntries)) {
  setAllValues((prev) => [...prev, ...newEntries]);

  reset({
    values: [{ value: "", show_to_user: 0 }],
  });
}
getCategoryById()
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
  const handleRemoveValueShow = (value) => {
    setValueId(value.id);
    setRemoveValueShow(true);
  };
  const handleRemoveValueClose = () => {
    setRemoveValueShow(false);
  };

  const deletePropertyValue = async () => {
    try {
      const response = await axios.delete(
        `${newHost}portal/properties/${propertyId}/values/${valueId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.data.message);
      handleRemoveValueClose()
      getCategoryById()
      const updated = allValues.filter((v) => v.id !== valueId);
      
      setAllValues(updated);
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <>
      <DeleteModal
        showDelete={removeValueShow}
        handleDeleteClose={handleRemoveValueClose}
        textMessage={
          " Are you sure you want to remove this value from Property?"
        }
        deleteFunction={deletePropertyValue}
      />
      <div className="p-3 mb-3 rounded-2">
        {allValues.map((value, idx) => (
         <React.Fragment  key={value.id || idx} >
         <div className="d-flex mt-2 align-items-center">
            <TextField
              className="w-100 me-2"
              value={value.value}
              size="small"
            />

            <IconButton onClick={() => handleRemoveValueShow(value)}>
              <DeleteOutlineOutlined color="error" />
            </IconButton>
          </div>
                  <div className="d-flex align-items-start gap-2 mx-2">
                  <input
                    type="checkbox"
                    className="my-1"
                    // onChange={(e) => e.target.checked ? 1 : 0} 
                  checked={value.show_to_user}
                  />
                  <div>
                    <p className="m-0 label-size">Show to user</p>
                  </div>
                </div> 
         </React.Fragment>
        ))}

        <form onSubmit={handleSubmit(createPropertyValue)}>
          {fields.map((field, index) => (
          <React.Fragment key={field.id}>
            <div key={field.id} className="d-flex mt-3 align-items-center">
              <TextField
                className="w-100 me-2"
                placeholder="Add value"
                size="small"
                {...register(`values.${index}.value`)}
              />

              <Button
                sx={{ backgroundColor: "black", mb: 1 }}
                type="submit"
                variant="contained"
              >
                Save
              </Button>
            </div>
            <div className="">
               <Controller
              name={`values.${index}.show_to_user`}
              control={control}
              defaultValue={0} 
              render={({ field: { onChange, value, ref } }) => (
                <div className="d-flex align-items-start gap-2 mx-2">
                  <input
                    type="checkbox"
                    className="my-1"
                    ref={ref}
                    checked={!!value} 
                    onChange={(e) => onChange(e.target.checked ? 1 : 0)} 
                  />
                  <div>
                    <p className="m-0 label-size">Show to user</p>
                  </div>
                </div>
              )}
            />
            </div>
          
          </React.Fragment>
          ))}
        </form>
      </div>
    </>
  );
};

const CategoryProfile = () => {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newHeaders = {
    Authorization: "Bearer " + token,
  };

  const { id } = useParams();

  const [value, setValue] = useState(0);

  const navigate = useNavigate();

  const goToBrandProfile = (brandId) => {
    navigate(`/Categories/${id}/brand/${brandId}`);
  };

  const goToSubcategoryProfile = (subId) => {
    navigate(`/Categories/${id}/subcategory/${subId}`);
  };

  // table columns & rows

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="w-100 d-flex align-items-center justify-content-center gab-3">
            <img
              style={{ width: "25px", height: "25px" }}
              className=" mx-2"
              src={
                params.row.logo_path
                  ? "https://estbn.com/EstbnNew/public" + params.row.logo_path
                  : defaultImage
              }
              alt=""
            />
            <span>{params.row?.name}</span>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "Created_on",
      headerName: "Created on",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <div>{new Date(params.row.created_at).toLocaleDateString()}</div>
        );
      },
    },
    {
      field: "operator",
      headerName: "Created by",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return <div>{params.row?.operator?.name}</div>;
      },
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                confirmDelete(params.row?.id);
              }}
              color="error"
              aria-label="delete"
              style={{ width: "30%" }}
              size="small"
            >
              <DeleteOutline />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                goToBrandProfile(params.row?.id);
              }}
              color="default"
              aria-label="navigate"
              style={{ width: "30%" }}
              size="small"
            >
              <RightOutlined />
            </IconButton>
          </div>
        );
      },
    },
  ];
  const paginationModel = { page: 0, pageSize: 5 };

  const subCatgoriesColumns = [
    {
      field: "name",
      headerName: "Name",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="w-100 d-flex align-items-center justify-content-center gab-3">
            <img
              style={{ width: "25px", height: "25px" }}
              className="mx-2"
              src={`https://estbn.com/EstbnNew/public/${params.row?.image_url}`}
              alt=""
            />
            <span className="">{params?.row.name}</span>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "created_at",
      headerName: "Created on",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <div>{new Date(params.row.created_at).toLocaleDateString()}</div>
        );
      },
    },
    {
      field: "operator",
      headerName: "Created by",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return <div>{params.row?.operator?.name}</div>;
      },
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                confirmSubDelete(params.row?.id);
              }}
              color="error"
              aria-label="delete"
              style={{ width: "30%" }}
              size="small"
            >
              <DeleteOutline />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                goToSubcategoryProfile(params.row?.id);
              }}
              color="default"
              aria-label="navigate"
              style={{ width: "30%" }}
              size="small"
            >
              <RightOutlined />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const propertiesColumns = [
    {
      field: "name",
      headerName: "Name",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="w-100 d-flex align-items-center justify-content-center gab-3">
            <img
              className="mx-2"
              src={`https://estbn.com/EstbnNew/public/${params.row?.image_url}`}
              alt=""
            />
            <span>{params?.row.name}</span>
          </div>
        );
      },
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "is_filterable",
      headerName: "Is Filterable",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => (
        <span>{params.row.is_filterable ? "True" : "False"}</span>
      ),
    },
    {
      field: "is_required",
      headerName: "Is Required",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => (
        <span>{params.row.is_required ? "True" : "False"}</span>
      ),
    },
    {
      field: "sort_order",
      headerName: "Sort Order",
      flex: 0.8,
      minWidth: 110,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
       
  
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              onClick={(e)=>{
              updateProprty(params.row)
              e.stopPropagation()
              }}
              color="default"
              aria-label="edit"
              style={{ width: "30%" }}
              size="small"
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={(e)=>
{                handleDeleteProperty(params.row)
                e.stopPropagation()
}              }
              color="error"
              aria-label="delete"
              style={{ width: "30%" }}
              size="small"
            >
              <DeleteOutline />
            </IconButton>
            <IconButton
              onClick={(e) => {
                handlePropertyProfileShow(e,params.row); 
              }}
              color="default"
              aria-label="view-details"
              style={{ width: "30%" }}
              size="small"
            >
              <RightOutlined />
            </IconButton>
          </div>
        );
      },
    },
  ];

  //  category data

  const [categoryById, setCategoryById] = useState(null);

  const getCategoryById = async () => {
    try {
      const response = await axios.get(`${newHost}portal/categories/${id}`, {
        headers: newHeaders,
      });
      console.log(response.data.data.category);
      setCategoryById(response.data.data.category);
    } catch (error) {
      console.log(error);
    }
  };

  // activation functions

  const [showActivate, setShowActivate] = useState(false);

  const handleActivateShow = () => {
    setShowActivate(true);
  };

  const handleActivateClose = () => {
    setShowActivate(false);
  };

  const activateCategories = async () => {
    const isActive = categoryById?.status === "active";
    const newStatus = isActive ? "inactive" : "active";

    try {
      const response = await axios.post(
        `${newHost}portal/categories/${id}`,
        {
          _method: "PATCH",
          status: newStatus,
        },
        {
          headers: newHeaders,
        }
      );
      console.log(response);
      getCategoryById();
      setShowActivate(false);
    } catch (error) {
      console.log(error);
    }
  };

  // delete brand functions

  const [showDelete, setShowDelete] = useState(false);

  const [brandId, setBrandId] = useState(null);

  const handleDeleteClose = () => {
    setShowDelete(false);
  };

  const confirmDelete = (id) => {
    console.log(id);

    setBrandId(id);
    setShowDelete(true);
  };

  const removeBrandFromCategory = async () => {
    try {
      const response = await axios.delete(
        `${newHost}portal/categories/${id}/brands/${brandId}`,
        {
          headers: newHeaders,
        }
      );
      console.log(response);
      toast.success(response.data.data.message);
      getCategoryById();
      setShowDelete(false);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data?.message);
    }
  };

  // delete subcategory functions

  const [showSubDelete, setShowSubDelete] = useState(false);

  const [subCategoryId, setSubCategoryId] = useState(null);

  const confirmSubDelete = (id) => {
    console.log(id);

    setSubCategoryId(id);
    setShowSubDelete(true);
  };

  const handleSubDeleteClose = () => {
    setShowSubDelete(false);
  };

  const removeSubCategoryFromMainCategory = async () => {
    try {
      const response = await axios.delete(
        `${newHost}portal/categories/${subCategoryId}`,
        {
          headers: newHeaders,
        }
      );
      console.log(response);
      toast.success(response.data.data.message);
      getCategoryById();
      setShowSubDelete(false);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data?.message);
    }
  };



  const handleCloseDeletePropertyModal = () => {
    setIsDeletePropertyModalOpen(false);
    setPropertyToDelete(null);
  };

  const handleDeletePropertyConfirmed = async () => {
   
      try {
        const response = await axios.delete(
          `https://estbn.com/EstbnNew/public/api/portal/properties/${propertyData.id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        toast.success(response.data.message)
       handleCloseDeletePropertyModal()
        getCategoryById(); 
      } catch (error) {
        console.log(error);
        
      }
    }
  

  // add subCategory

  const [isSubCategory, setIsSubCategory] = useState(false);

  const handleShowSubCategory = () => {
    setAddMainCatigory({
      image: "",
      fileUrl: "",
      name: "",
      description: "",
      status: "",
    });
    setIsSubCategory(true);
    setShow(true);
  };

  // edit side

  const [addMainCatigory, setAddMainCatigory] = useState({
    image: "",
    fileUrl: "",
    description: "",
    name: "",
    status: "",
  });

  const [editCategoryId, setEditCategoryId] = useState(null);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    setIsSubCategory(false);
    setEditCategoryId(null);
  };

  const handleEditCategory = (category) => {
    console.log(category);

    const fullImageUrl = category?.image_url?.startsWith("http")
      ? category.image_url
      : category?.image_url
      ? `https://estbn.com/EstbnNew/public${category.image_url}`
      : "path/to/default-image.jpg";

    setAddMainCatigory({
      icon_url: "",
      fileUrl: fullImageUrl,
      name: category.name,
      description: category.description,
      status: category.status,
    });
    setFormValue("name", category.name);
    setFormValue("description", category.description);
    setFormValue("status", category.status);
    setEditCategoryId(category.id);
    setShow(true);
  };

  const onSubmitAddMainCatogiry = () => {
    // const token = "1|uXWWHVAxUbLR94IuQ07nZUT5306vlnjfGFo4AUoR16bcf002";

    const token = user?.token;

    const headers = {
      Authorization: "Bearer " + token,
    };

    const formData = new FormData();

    if (isSubCategory) {
      formData.append("parent_id", id);
    } else {
      formData.append("_method", "PATCH");
    }

    if (addMainCatigory.image) {
      formData.append("image", addMainCatigory.image);
    }
    formData.append("name", addMainCatigory.name);
    formData.append("description", addMainCatigory.description);
    formData.append("status", addMainCatigory.status);

    const url = isSubCategory
      ? `${newHost}portal/categories`
      : `${newHost}portal/categories/${editCategoryId}`;

    axios
      .post(url, formData, { headers })
      .then((response) => {
        console.log(response.data);
        toast.success(
          isSubCategory
            ? "Sub Category Added Succeddfully"
            : "Category Updated Successfully",
          { autoClose: 3000 }
        );
        setAddMainCatigory({
          icon_url: "",
          description: "",
          name: "",
          status: "",
        });
        getCategoryById();
        handleClose();
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  const {
    register,
    handleSubmit,
    setValue: setFormValue,
    formState: { errors, isSubmitting },
  } = useForm();

  // delete side

  const [showSideDelete, setShowSideDelete] = useState(false);

  const handleSideDeleteClose = () => {
    setShowSideDelete(false);
  };


  const confirmSideDelete = () => {
    setShowSideDelete(true);
  };

  const deleteCategory = async () => {
    try {
      let response = await axios.delete(`${newHost}portal/categories/${id}`, {
        headers: newHeaders,
      });
      toast.warning("Category Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleSideDeleteClose();
      navigate("/Categories");
      getCategoryById();
    } catch (error) {
      toast.error("Failed To Delete This Category.");
      console.log(error.message);
    }
  };

  useEffect(() => {
    getCategoryById();
  }, []);


   // property
   const [propertyTypes, setPropertyTypes] =  useState([])
   const [editProperty, setEditProperty] = useState(false)
   const [propertyId, setPropertyId] = useState(null)
  const handleDeleteProperty = (property)=>{
    setPropertyData(property)
    setIsDeletePropertyModalOpen(true)

  }

  const {
  register: propertyRegister,
  handleSubmit: propertySubmit,
  reset:propertyReset,
  control: propertyControl

  } = useForm({
    defaultValues:{
      name: "",
      sort_order:"",
      Type: null,
      is_filterable: 0,
      is_required: 0,
      is_general: 0,
      show_to_user: 0
   
    }
  })
  
  const [showAddPropertyModal, setShowAddPropertyModal] = useState(false);

  const [updatePropertyModalOpen, setUpdatePropertyModalOpen] = useState(false);

  const [selectedPropertyData, setSelectedPropertyData] = useState(null);

  const [isDeletePropertyModalOpen, setIsDeletePropertyModalOpen] =
    useState(false);

  const [propertyToDelete, setPropertyToDelete] = useState(null);

  const [propertyProfileShow, setPropertyProfileShow] =
    useState(false);

    const [propertyData, setPropertyData] = useState({});
  

  const handleOpenAddPropertyModal = () => {
    setShowAddPropertyModal(true)
    setEditProperty(false)
     propertyReset({
      name: "",
      sort_order:"",
      Type: null,
      is_filterable: 0,
      is_required: 0,
      is_general: 0,
      show_to_user: 0
    })
  }

  const handleCloseAddPropertyModal = () => {
    setShowAddPropertyModal(false);
    propertyReset({
      name: "",
      sort_order:"",
      Type: null,
      is_filterable: 0,
      is_required: 0,
      is_general: 0,
      show_to_user: 0
    })
    setEditProperty(false)
  }

 

  const handlePropertyProfileShow = (e, properity) => {
    e.stopPropagation();
    setPropertyProfileShow(true);
    setPropertyData(properity);
  };

  const handlePropertyProfileClose = () => {
    setPropertyProfileShow(false);

  };
  
  const getPropertyTypes = async ()=>{
    try {
      const response = await axios.get(`${newHost}portal/property-types`,{
        headers: {Authorization:`Bearer ${token}`}
      })
      setPropertyTypes(response.data.data?.property_types)
    } catch (error) {
      console.log(error);
      
    }
  }
  useEffect (()=>{
    getPropertyTypes()
  }, [])
 
    const updateProprty = (property)=>{
        setShowAddPropertyModal(true)
        setEditProperty(true)
        setPropertyId(property.id)
       propertyReset({
          name: property.name,
          type: property.type,
          sort_order: property.sort_order,
          is_filterable: property.is_filterable? 1 : 0  ,
          is_required: property.is_required? 1 : 0,
          is_general: property.is_general? 1 : 0,
          show_to_user: property.show_to_user? 1 : 0
        })
    }

    const handleSubmitProperty = async (data) => {

    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("type", data.type);
    formData.append("sort_order", data.sort_order);
    formData.append("is_filterable", data.is_filterable);
    formData.append("is_required", data.is_required);
    formData.append("is_general", data.is_general);
    formData.append("show_to_user", data.show_to_user);
    formData.append("category_id", id
    );
    
    

    if(editProperty){
      formData.append("_method", "PUT"
    );
       try {
       const response = await axios.post(`${newHost}portal/properties/${propertyId}`,formData,{
        headers: {Authorization:`Bearer ${token}`}
      })
      handleCloseAddPropertyModal()
      getCategoryById()
      toast.success(response.data.message)
    } catch (error) {
      toast.error(error.response.data.message)
    }
    }else{
  try {
       const response = await axios.post(`${newHost}portal/properties`,formData,{
        headers: {Authorization:`Bearer ${token}`}
      })
      handleCloseAddPropertyModal()
      getCategoryById()
      toast.success(response.data.message)
    } catch (error) {
      toast.error(error.response.data.message)
    }
    }

  

  };
  return (
    <>
      {/* edit  */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isSubCategory ? "Add Subcategory" : "Edit Category"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmitAddMainCatogiry)}>
            {/* image  */}
            <div className="flex-center-x-y">
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                {...register("image")}
                id="icon_url"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const allowedTypes = [
                      "image/jpeg",
                      "image/png",
                      "image/jpg",
                      "image/gif",
                      "image/svg+xml",
                    ];
                    if (allowedTypes.includes(file.type)) {
                      const imageUrl = URL.createObjectURL(file);
                      setAddMainCatigory({
                        ...addMainCatigory,
                        image: file,
                        fileUrl: imageUrl,
                      });
                    } else {
                      toast.error(
                        "Please select a valid image file (jpeg, png, jpg, gif, svg)."
                      );
                      setAddMainCatigory({
                        ...addMainCatigory,
                        image: "",
                        fileUrl: "",
                      });
                    }
                  }
                }}
              />
              <label htmlFor="icon_url" className="categories_photo">
                {addMainCatigory.fileUrl ? (
                  <img
                    className="categories-add"
                    src={addMainCatigory.fileUrl}
                    alt="Selected"
                  />
                ) : (
                  <img
                    src={addMainCatigory.fileUrl || AddPhoto}
                    alt="Category"
                  />
                )}
                <div className="categories_cameraIcon">
                  <img src={Camera} alt="" />
                </div>
              </label>
              {errors.image && <p className="danger">{errors.image.message}</p>}
            </div>
            {/* name */}
            <div className="row">
              <div className="col-12">
                <TextField
                  className="w-100 mb-3"
                  label="Category Name"
                  variant="outlined"
                  {...register("name")}
                  value={addMainCatigory.name}
                  onChange={(e) => {
                    setAddMainCatigory({
                      ...addMainCatigory,
                      name: e.target.value,
                    });
                  }}
                />
                {errors.name && <p className="danger">{errors.name.message}</p>}
              </div>
            </div>
            {/* description  */}
            <TextField
              className="w-100 mb-3"
              label="Category Description"
              variant="outlined"
              rows={4}
              multiline
              {...register("description")}
              value={addMainCatigory.description}
              onChange={(e) => {
                setAddMainCatigory({
                  ...addMainCatigory,
                  description: e.target.value,
                });
              }}
            />
            {errors.description && (
              <p className="danger">{errors.description.message}</p>
            )}
            {/* status  */}
            <div className="row">
              <div className="col-12">
                <FormControl className="w-100 mb-3" variant="outlined">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    label="Status"
                    {...register("status")}
                    value={addMainCatigory.status}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        status: e.target.value,
                      });
                    }}
                  >
                    <MenuItem className="custom-menu-item" value="active">
                      Active
                    </MenuItem>
                    <MenuItem className="custom-menu-item" value="inactive">
                      Inactive
                    </MenuItem>
                  </Select>
                </FormControl>
                {errors.status && (
                  <p className="danger">{errors.status.message}</p>
                )}
              </div>
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* delete side  */}
      <DeleteModal
        showDelete={showSideDelete}
        handleDeleteClose={handleSideDeleteClose}
        textMessage={" Are you sure you want to delete this category?"}
        deleteFunction={deleteCategory}
      />
      {/* delete brand  */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to remove this Brand?"}
        deleteFunction={removeBrandFromCategory}
      />
      {/* delete sub category  */}
      <DeleteModal
        showDelete={showSubDelete}
        handleDeleteClose={handleSubDeleteClose}
        textMessage={" Are you sure you want to remove this Sub Category?"}
        deleteFunction={removeSubCategoryFromMainCategory}
      />
      {/* delete property  */}
      <DeleteModal
        showDelete={isDeletePropertyModalOpen}
        handleDeleteClose={handleCloseDeletePropertyModal}
        textMessage={" Are you sure you want to remove this Property?"}
        deleteFunction={handleDeletePropertyConfirmed}
      />
        <Modal show={showAddPropertyModal} onHide={handleCloseAddPropertyModal} dialogClassName="custom-modal-campaigns-width">
        <Modal.Header>
          <Modal.Title>
            Add Property
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={propertySubmit(handleSubmitProperty)}>
       <div className="my-3">
      <label htmlFor="name">Property Name</label>
      <TextField {...propertyRegister("name", 
        )} className="w-100 m-0" type="text" size="small" id="name" placeholder="Add property Name"/>
                           
       </div>
               <div className="my-3">
                    <label htmlFor="type">Type</label>
                             <Controller
                  name="type"
                  control={propertyControl}
                  render={({ field }) => {
                    const options = propertyTypes.map((type)=>{
                    return(
                      {
                        label : type,
                        id: type
                      }
                    )
                  })
    
                    return (
                      <Autocomplete
                      className='w-100'
                        size="small"
                        options={options}
                        value={options.find(opt => opt.id == field.value) || null}
                        id='type'
                        onChange={(e, item) => {
                          field.onChange(item ? item.id : null);
                        }}
    
                        renderOption={(props, option) => (
                          <li {...props} className="p-2">
                            {option.label}
                          </li>
                        )}
    
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="m-0"
                            placeholder="Add property type"
                          />
                        )}
                      />
                    );
                  }}
    />
        
                  </div>
         <div className="my-3">
      <label htmlFor="sort_order">Sort Order</label>
      <TextField {...propertyRegister("sort_order", 
        )} className="w-100 m-0" type="number" size="small" id="sort_order" placeholder="Add sort order"/>
                           
       </div>
       <div className="row mt-4">
          <div className="col-md-3 col-6">
            <Controller
              name="is_required"
              control={propertyControl}
              defaultValue={0} 
              render={({ field: { onChange, value, ref } }) => (
                <div className="d-flex align-items-start gap-2 mx-2">
                  <input
                    type="checkbox"
                    className="my-1"
                    ref={ref}
                    checked={!!value} 
                    onChange={(e) => onChange(e.target.checked ? 1 : 0)} 
                  />
                  <div>
                    <p className="m-0 label-size">Required</p>
                  </div>
                </div>
              )}
            />
          </div>
          <div className="col-md-3 col-6">
            <Controller
              name="is_filterable"
              control={propertyControl}
              defaultValue={0} 
              render={({ field: { onChange, value, ref } }) => (
                <div className="d-flex align-items-start gap-2 mx-2">
                  <input
                    type="checkbox"
                    className="my-1"
                    ref={ref}
                    checked={!!value} 
                    onChange={(e) => onChange(e.target.checked ? 1 : 0)} 
                  />
                  <div>
                    <p className="m-0 label-size">Filterable</p>
                  </div>
                </div>
              )}
            />
          </div>
          <div className="col-md-3 col-6">
            <Controller
              name="is_general"
              control={propertyControl}
              defaultValue={0} 
              render={({ field: { onChange, value, ref } }) => (
                <div className="d-flex align-items-start gap-2 mx-2">
                  <input
                    type="checkbox"
                    className="my-1"
                    ref={ref}
                    checked={!!value} 
                    onChange={(e) => onChange(e.target.checked ? 1 : 0)} 
                  />
                  <div>
                    <p className="m-0 label-size">General</p>
                  </div>
                </div>
              )}
            />
          </div>
          <div className="col-md-3 col-6">
            <Controller
              name="show_to_user"
              control={propertyControl}
              defaultValue={0} 
              render={({ field: { onChange, value, ref } }) => (
                <div className="d-flex align-items-start gap-2 mx-2">
                  <input
                    type="checkbox"
                    className="my-1"
                    ref={ref}
                    checked={!!value} 
                    onChange={(e) => onChange(e.target.checked ? 1 : 0)} 
                  />
                  <div>
                    <p className="m-0 label-size">Show to user</p>
                  </div>
                </div>
              )}
            />
          </div>
       </div>
       <div className="d-flex gap-3 align-items-center justify-content-center mt-4 mb-3">
        <button className="btn btn-dark px-5">Save</button>
        <button type="reset" onClick={handleCloseAddPropertyModal} className="btn btn-light px-5">Cancel</button>
       </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal show={propertyProfileShow} onHide={handlePropertyProfileClose}>
              <Modal.Header closeButton>
                <Modal.Title className="m-0">Property Profile</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="my-4 mx-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="m-0">Property Info</h6>
                    <div
                      className="cursor"
                      onClick={(e) => {
                        updateProprty(propertyData);
                        setPropertyProfileShow(false);
                      }}
                    >
                      <Edit />
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-lg-6 col-12">
                      <div className="my-3">
                        <div className="d-flex gap-1 align-items-center my-1">
                          <h6 className="main-text-color m-0">Name:</h6>
                          <h6 className="m-0">{propertyData.name}</h6>
                        </div>
                        <div className="d-flex gap-1 align-items-center my-1">
                          <h6 className="main-text-color m-0">Is Filterable:</h6>
                          <h6 className="m-0">
                            {String(propertyData.is_filterable)}
                          </h6>
                        </div>
                        <div className="d-flex gap-1 align-items-center my-1">
                          <h6 className="main-text-color m-0">Is Required:</h6>
                          <h6 className="m-0">
                             {String(propertyData.is_required)}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-12">
                      <div className="my-3">
                          <div className="d-flex gap-1 align-items-center my-1">
                          <h6 className="main-text-color m-0">Is General:</h6>
                          <h6 className="m-0">{String(propertyData.is_general)}</h6>
                        </div>
                          <div className="d-flex gap-1 align-items-center my-1">
                           
                            <h6 className="main-text-color m-0">show to user:</h6>
                            <h6 className="m-0">{String(propertyData.show_to_user)}</h6>
                          </div>
                        <div className="d-flex gap-1 align-items-center my-1">
                          <h6 className="main-text-color m-0">Type:</h6>
                          <h6 className="m-0">{propertyData.type}</h6>
                        </div> 
                   
                      
                      </div>
                    </div>
                  </div>
                  <PropertiesValues
                   getCategoryById={getCategoryById}
                    token={token}
                    properityValues={propertyData.values}
                    propertyId={propertyData.id}
                  />
                </div>
              </Modal.Body>
            </Modal>

      {/* handle active  */}
      <Modal show={showActivate} onHide={handleActivateClose} className="">
        <>
          <div className="text-center py-4">
            {" "}
            <h3>
              {categoryById?.status == "active" ? "Inactivate" : "Activate"}{" "}
              Category
            </h3>
          </div>

          <div className="text-center py-2  px-3">
            <h6 style={{ color: "#535353" }} className="fs-4">
              Are you sure you want to{" "}
              {categoryById?.status == "active" ? "inactivate" : "activate"}{" "}
              <span className="fw-bold d-block">
                {categoryById?.name} category?
              </span>
            </h6>
          </div>
          <div>
            <div className="d-flex justify-content-center align-items-center gap-3 py-3">
              <button
                onClick={handleActivateClose}
                className="btn btn-light px-5"
              >
                Cancel
              </button>
              <button
                onClick={activateCategories}
                className={`btn  ${
                  categoryById?.status == "active"
                    ? "btn-danger"
                    : "btn-success"
                } px-5`}
              >
                {categoryById?.status == "active"
                  ? "Inactivate Category"
                  : "Activate Category"}
              </button>
            </div>
          </div>
        </>
      </Modal>
      <div className="min-vh-100 mx-4 my-3">
        {/* Head Section */}
        <div className="row align-items-center mb-3">
          <div className="col-12 col-lg-4 col-xl-3 mb-2 mb-xl-0">
            <h5 className="fw-semibold">Category Profile</h5>
          </div>
          <div className="col-12 col-lg-8 col-xl-9">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
              {/* Tabs Section */}
              <div
                className="w-100 rounded-3"
                style={{
                  WebkitOverflowScrolling: "touch",
                  overflowX: "auto",
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <BottomNavigation
                    showLabels
                    value={value}
                    onChange={(event, newValue) => setValue(newValue)}
                    sx={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      paddingY: "1px",
                      height: "45px",
                      ".Mui-selected": {
                        fontWeight: 550,
                      },
                      ".MuiBottomNavigationAction-root": {
                        fontSize: "14px",
                        borderRadius: "6px",
                      },
                    }}
                  >
                    <BottomNavigationAction label="Brands" />
                    <BottomNavigationAction label="Sub Categories" />
                    <BottomNavigationAction label="Properties" />
                  </BottomNavigation>
                </Box>
              </div>
              {/* Action Button */}
              <div className="text-md-end w-100 w-md-auto mt-3 mt-md-0">
                <button
                  onClick={handleActivateShow}
                  className={`btn ${
                    categoryById?.status === "active"
                      ? "btn-danger"
                      : "btn-success"
                  } px-3 py-2`}
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  {categoryById?.status === "active"
                    ? "Inactivate Category"
                    : "Activate Category"}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Body Section */}
        <div className="row">
          {/* Side Card */}
          <div className="col-12 col-lg-4 col-xl-3">
            <div className="border border-2 rounded-3 p-3 h-100">
              <div className="bg-light rounded-4 text-center px-3 py-2">
                <div className="supplier_imgHulder">
                  <img
                    src={`https://estbn.com/EstbnNew/public${categoryById?.image_url}`}
                    alt="Profile"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-4 pt-2">
                <h5 className="fw-bold">{categoryById?.name} Category</h5>
                <div className="d-flex gap-2">
                  <div
                    className="categoryImgCard cursor"
                    onClick={() => handleEditCategory(categoryById)}
                  >
                    <img src={Pan} alt="Edit" />
                  </div>
                  <div
                    className="categoryImgCard cursor"
                    onClick={confirmSideDelete}
                  >
                    <img src={deleteIcon} alt="Delete" />
                  </div>
                </div>
              </div>

              <div className="stuffprofileinfo_supplierProfile my-2">
                <div className="agentInfo-Supp">Category Info</div>
                <div className="d-flex gap-2 align-items-center my-1">
                  <Person fontSize="small" />
                  <p className="fw-semibold m-0">
                    {categoryById?.operator?.name}
                  </p>
                </div>
                <div className="d-flex gap-2 align-items-center my-1">
                  <CalendarTodayIcon fontSize="small" />
                  <p className="fw-semibold m-0">
                    {`Created On ${new Date(
                      categoryById?.created_at
                    ).toLocaleDateString()}`}
                  </p>
                </div>
                <div className="d-flex gap-2 align-items-center my-1">
                  <CircleIcon
                    fontSize="small"
                    color={
                      categoryById?.status === "active" ? "success" : "disabled"
                    }
                  />
                  <p className="fw-semibold m-0">{categoryById?.status}</p>
                </div>
                <div className="d-flex gap-2 align-items-start my-1">
                  <InfoOutlined fontSize="small" />
                  <p className="categoryInfo">{categoryById?.description}</p>
                </div>
              </div>

              <div className="stuffprofileinfo_supplierProfile mt-0">
                <div className="agentInfo-Supp">Sub Categories</div>
                {categoryById?.children?.map((sub) => (
                  <div
                    key={sub?.name}
                    className="d-flex gap-2 align-items-center my-1"
                  >
                    <Square sx={{ fontSize: "10px" }} />
                    <p className="fw-semibold m-0">{sub?.name}</p>
                  </div>
                ))}
                <div className="agentInfo-Supp mt-3">Properties</div>
                {categoryById?.properties?.map((prop) => (
                  <div
                    key={prop?.name}
                    className="d-flex gap-2 align-items-center my-1"
                  >
                    <Square sx={{ fontSize: "10px" }} />
                    <p className="fw-semibold m-0">{prop?.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* Main Content */}
          <div className="col-12 col-lg-8 col-xl-9">
            <div className="w-100 border border-2 rounded-3 p-3">
              {value === 0 ? (
                <>
                  <h4>Brands</h4>
                  <div className="my-4">
                    {categoryById?.brands?.length > 0 ? (
                      <div className="scrollable-table-wrapper">
                        <div>
                          <Paper sx={{ width: "100%" }}>
                            <DataGrid
                              rows={categoryById?.brands}
                              columns={columns}
                              initialState={{ pagination: { paginationModel } }}
                              pageSizeOptions={[5, 10]}
                              checkboxSelection
                              sx={{ border: 0 }}
                              slotProps={{
                                pagination: {
                                  sx: {
                                    justifyContent: "center",
                                    display: "flex",
                                    alignItems: "center",
                                  },
                                },
                              }}
                            />
                          </Paper>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="d-flex justify-content-center align-items-center w-100"
                        style={{ minHeight: "300px" }}
                      >
                        <NotFound paragraphText="No Brands Added Yet" />
                      </div>
                    )}
                  </div>
                </>
              ) : value === 1 ? (
                <>
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-3">
                    <h5 className="m-0">Sub Categories</h5>
                    <button
                      className="btn btn-light"
                      onClick={handleShowSubCategory}
                    >
                      <Add /> Add Sub Category
                    </button>
                  </div>
                  <div className="my-4">
                    {categoryById?.children?.length > 0 ? (
                      <div className="scrollable-table-wrapper">
                        <div>
                          <Paper sx={{ width: "100%" }}>
                            <DataGrid
                              rows={categoryById.children}
                              columns={subCatgoriesColumns}
                              initialState={{ pagination: { paginationModel } }}
                              pageSizeOptions={[5, 10]}
                              checkboxSelection
                              sx={{ border: 0 }}
                              slotProps={{
                                pagination: {
                                  sx: {
                                    justifyContent: "center",
                                    display: "flex",
                                    alignItems: "center",
                                  },
                                },
                              }}
                            />
                          </Paper>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="d-flex justify-content-center align-items-center w-100"
                        style={{ minHeight: "300px" }}
                      >
                        <NotFound paragraphText="No Subcategories Added Yet" />
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-3">
                    <h5 className="m-0">Properties</h5>
                    <button
                      className="btn btn-light"
                      onClick={handleOpenAddPropertyModal}
                    >
                      <Add /> Add Property
                    </button>
                  </div>
                  <div className="my-4">
                    {categoryById?.properties?.length > 0 ? (
                      <div className="scrollable-table-wrapper">
                        <div>
                          <Paper sx={{ width: "100%" }}>
                            <DataGrid
                              rows={categoryById.properties}
                              columns={propertiesColumns}
                              initialState={{ pagination: { paginationModel } }}
                              pageSizeOptions={[5, 10]}
                              checkboxSelection
                              sx={{ border: 0 }}
                              slotProps={{
                                pagination: {
                                  sx: {
                                    justifyContent: "center",
                                    display: "flex",
                                    alignItems: "center",
                                  },
                                },
                              }}
                            />
                          </Paper>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="d-flex justify-content-center align-items-center w-100"
                        style={{ minHeight: "300px" }}
                      >
                        <NotFound paragraphText="No Properties Added Yet" />
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryProfile;
